// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3f9CR","label":"Radio_label__3EBY2","checkMark":"Radio_checkMark__2As45","disabled":"Radio_disabled__3Sz06"};